import { render, staticRenderFns } from "./media_management.vue?vue&type=template&id=1d0da06a&"
import script from "./media_management.vue?vue&type=script&lang=js&"
export * from "./media_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports